export const css = {
	root: '_1RGAuoCP',
	inputWrapper: '_2YSMIqnR',
	track: '_3AQ0bBP-',
	fill: '_2oeLfpO9',
	thumb: 'Ugyi1YAm',
	input: '_2oQNcyTc',
	outputTooltip: '_1Xl0AW_I',
	output: '_3uXPMRsm',
	vertical: 'GdaBFjNg',
	disabled: '_2IKl_n-P',
	readonly: '_2pqiY-Z1',
	invalid: '_2EM0UiP_',
	valid: '_2okjYqVW',
	' _key': 'apic-theme/dojo/slider'
};

export default css;
